enum LogisticsCompany {
  AIR = "AIR",
  ANDE = "ANDE",
  ANE56 = "ANE56",
  ANE66 = "ANE66",
  AXWL = "AXWL",
  BEST = "BEST",
  BESTGJ = "BESTGJ",
  BESTQJT = "BESTQJT",
  BHWL = "BHWL",
  BSYP = "BSYP",
  CF = "CF",
  CNDTK = "CNDTK",
  CNEX = "CNEX",
  CRE = "CRE",
  CYWL = "CYWL",
  DANGDANG = "DANGDANG",
  DBKD = "DBKD",
  DBL = "DBL",
  DFH = "DFH",
  DN = "DN",
  DSJZ = "DSJZ",
  DSWL = "DSWL",
  DTW = "DTW",
  EMS = "EMS",
  ESB = "ESB",
  EWE = "EWE",
  EXFRESH = "EXFRESH",
  EYB = "EYB",
  FAST = "FAST",
  FEDEX = "FEDEX",
  FENGWANG = "FENGWANG",
  FW = "FW",
  FYP = "FYP",
  FYPS = "FYPS",
  GGTCTK = "GGTCTK",
  GJWL = "GJWL",
  GTO = "GTO",
  HMZJB = "HMZJB",
  HOAU = "HOAU",
  HQWL = "HQWL",
  HTKY = "HTKY",
  HUAQIEX = "HUAQIEX",
  HYWL = "HYWL",
  JD = "JD",
  JDKY = "JDKY",
  JD_EXPRESS = "JD_EXPRESS",
  JD_HPCP = "JD_HPCP",
  JIUYESCM = "JIUYESCM",
  JT = "JT",
  JYMWL = "JYMWL",
  KHWL = "KHWL",
  KUAYUE = "KUAYUE",
  KXTX = "KXTX",
  LB = "LB",
  LWT = "LWT",
  NDSD = "NDSD",
  PJBEST = "PJBEST",
  POST = "POST",
  POSTB = "POSTB",
  POSTS = "POSTS",
  QFKD = "QFKD",
  QH = "QH",
  QRT = "QRT",
  RFD = "RFD",
  RRS = "RRS",
  SDSD = "SDSD",
  SF = "SF",
  SFKY = "SFKY",
  SNWL = "SNWL",
  STE56 = "STE56",
  STO = "STO",
  STO56 = "STO56",
  STOGJ = "STOGJ",
  SURE = "SURE",
  SUT56 = "SUT56",
  SXJD = "SXJD",
  SZKKE = "SZKKE",
  TOPSPEED = "TOPSPEED",
  TTKDEX = "TTKDEX",
  TTWLKD = "TTWLKD",
  UAPEX = "UAPEX",
  UC = "UC",
  WOWVIP = "WOWVIP",
  WSKD = "WSKD",
  WSPY = "WSPY",
  WTO = "WTO",
  WXWL = "WXWL",
  XBWL = "XBWL",
  XFWL = "XFWL",
  XLOBO = "XLOBO",
  YC = "YC",
  YCKY = "YCKY",
  YMDD = "YMDD",
  YTO = "YTO",
  YTOGJ = "YTOGJ",
  YTO_CND = "YTO_CND",
  YTWL = "YTWL",
  YUNDA = "YUNDA",
  YUNDA56 = "YUNDA56",
  YUNDAGJ = "YUNDAGJ",
  YUNDA_DTD = "YUNDA_DTD",
  YUNDA_TC = "YUNDA_TC",
  ZJS = "ZJS",
  ZTO = "ZTO",
  ZTO56 = "ZTO56",
  ZTOGJ = "ZTOGJ",
  ZY = "ZY",
  ZYEHQ = "ZYEHQ",
  ZYSF = "ZYSF",
  ZZSY = "ZZSY",
  JSD = "JSD",
  JAX = "JAX",
  HSYSD = "HSYSD",
}

export default LogisticsCompany;
